// extracted by mini-css-extract-plugin
module.exports = {"centered":"Table_centered__BTvSg"};